module.exports = __webpack_public_path__ + "img/newenergyconference-pc.dcd49f95.png";